import type { Address } from "@/interfaces/address";
import { CustomAxiosRequestConfig } from "@/interfaces/customAxiosRequestConfig";
import axios from "@/lib/axios";
import { useMutation, useQuery } from "@tanstack/vue-query";

interface CompanyAddress {
  addressId?: number;
  companyId?: number;
  zipcode: string;
  number: string;
  street: string;
  neighborhood: string;
  cityId?: string;
  latitude?: number | string;
  longitude?: number | string;
  addressable_type?: string;
  addressable_id?: number;
}

const getCompanyAddress = async (companyId: number | string) => {
  const { data } = await axios.get<Address>(
    `/api/companies/${companyId}/addresses`,
    { errorHandling: false } as CustomAxiosRequestConfig,
  );
  return data;
};

export const createCompanyAddress = async (params: CompanyAddress) => {
  const { data } = await axios.post<Address>(
    `/api/companies/${params.companyId}/addresses`,
    params,
  );
  return data;
};

const useCompanyAddress = (companyId?: number) => {
  const createMutation = useMutation(createCompanyAddress);

  const { data, isLoading, isError, refetch } = useQuery(
    ["companyAddress", companyId],
    () => getCompanyAddress(companyId!),
    {
      enabled: !!companyId,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  return {
    data,
    isError,
    isLoading,
    createMutation,
    refetch,
  };
};

export default useCompanyAddress;
